import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from '../site-header/SiteHeader';
import Footer from '../../templates/homePageSections/footer/Footer';
import Messaging from '../../atoms/messaging/Messaging';

const Layout = () => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, '');

  const isHome = path === '';
  const isHistory = path.startsWith('/about/history');
  const isSubmitResearch = path.startsWith('/research/submit-research');

  const showHeader = !isHistory;

  const showFooter = !isHome && !isSubmitResearch;

  const showMessaging = !isHome && !isHistory;

  return (
    <>
      {showHeader && <SiteHeader />}
      <Outlet />

      {showMessaging && <Messaging />}
      {showFooter && <Footer />}
    </>
  );
};

export default Layout;
